<template >
    <div class="container pos-r">
        <Header title="课程收入"/>
        <img class="page-bg" :src="Images.img_page_bg2" alt="">
        <div class="header">
            <div class="account-info-wrap ccc">
                <div class="info-wrap flex ccc f-fff">
                    <p class="value">{{dataSources.total_points || 0}}</p>
                    <span class="title">可用积分</span>
                </div>
            </div>
        </div>
        <div class="detail pos-r">
            <div class="left">
                <div>
                    <img :src="Images.icon_wallet_yellow" alt="">
                    <p>积分明细</p>
                </div>
            </div>
            <div class="right" @click="isShowDatePicker = true">
                <p>{{_formatterCurDate}}</p>
                <img :src="Images.icon_screen" alt="">
            </div>
        </div>
        <div
            class="scrollerView"
            :style="{ height: (wrapperHeight- 320) + 'px' }"
        >
            <scroller
                :on-refresh="_onRefresh"
                :on-infinite="_onEndReached"
                :noDataText="listData.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                ref="infinite"
                class="scroller"
            >
                <myPointItem v-for="(item, index) in listData" :key="index" :item="item"/>
                <van-empty description="暂无信息～" v-if="listData.length < 1 && !loading" />
            </scroller>
        </div>

        <van-popup v-model="isShowDatePicker" position="bottom">
            <van-datetime-picker
                type="year-month"
                title="选择查询月份"
                v-model="currentDate"
                @confirm="_onConfirmPickerDate"
                @cancel="isShowDatePicker = false"
            />
        </van-popup>
    </div>
</template>

<script>
import moment, { locales } from 'moment';
import Header from '@/components/Header'
import myPointItem from '@/components/item/myPointItem'
export default {
    components: {
        'Header': Header,
        'myPointItem': myPointItem,
    },
    computed: {
        _formatterCurDate() {
            return moment(this.currentDate).format('YYYY-MM');
        }
    },
    data() {
        return {
            loading: false,
            isShowDatePicker: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            keyword: '',
            page: 0,
            limit: 10,
            dataSources: {},
            listData: [],
            no_more: false,
            no_data: false,
            currentDate: new Date(),
            user_type: this.$route.query.user_type || '',
            account_type: this.$route.query.account_type || '',
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this._requestDataSources();
    },
    methods: {
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            console.log('url---->', url);
            window.location.href = url;
        },

        _onConfirmPickerDate(value) {
            console.log('value---->', value);
            this.currentDate = value;
            this.isShowDatePicker = false;
            !this.loading && this._onRefresh();
        },

        async _requestDataSources() {
            let url = this.API.my_points_info;
            let data = {
                page: this.page,
                limit: this.limit,
                create_time: moment(this.currentDate).format('YYYY-MM'),
            };
            try {
                this.loading = true;
                const result = await this.$post(url, data);
                let dataSourcesTemp = this.listData.slice();
                let dataList = [];
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    this.dataSources = result.data;
                    dataList = result.data.data || [];
                    if (parseInt(data.page) === 1) {
                        dataSourcesTemp = dataList
                    } else {
                        if (dataList.length !== 0) {
                            dataSourcesTemp = dataSourcesTemp.concat(dataList);
                        }
                    }
                }
                this.listData = dataSourcesTemp;
                this._onStopLoading(dataList.length < this.limit);
            } catch (error) {
                console.log('error---->', error);
                this._onStopLoading(true);
            }
        },

        // 下拉刷新
        _onRefresh() {
            this.page = 1;
            this._requestDataSources();
        },

        // 上拉加载
        _onEndReached() {
            if (this.loading) return;
            this.page++;
            this._requestDataSources();
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log('status---->', status, this.dataSources);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },
    },
};
</script>

<style lang="less" scoped>
.page-bg {
    top: 0;
    z-index: 0;
    width: 100%;
    position: absolute;
}

.scrollerView {
    position: relative;
    width: calc(100% - 30px);
    margin: 10px 15px 0;
    box-sizing: border-box;
}

.scroller {
    background: #fff;
    box-sizing: border-box;
}

.header {
    position: relative;
    z-index: 1;
    height: 100px;
    padding: 10px;
    margin: 15px 15px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column; 
    justify-content: center;

   
    .account-info-wrap {
        display: flex;
        align-items: center;

        .title {
            font-size: 16px;
        }

        .value {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 1rem;
        }
    }
}

.detail {
    height: 64px;
    margin: 10px 15px 0;
    padding: 10px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 3px;
    box-shadow: 0px 4px 13px 0px rgba(10,24,99,0.06);
    display: flex; 
    align-items: center;

    .left {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        > div {
            display: flex;
            align-items: center;

            > img {
                width: 15px;
                height: 15px;
                margin-right: 5px;
            }

            > p {
                font-size: 15px;
                color: #333;
            }
        }

        > p {
            font-size: 13px;
            color: #7181EB;
        }
    }

    .right {
        width: 130px;
        height: 30px;
        padding: 0 10px;
        box-sizing: border-box;
        background: #f8f8f8;
        display: flex;
        align-items: center;


        p {
            flex: 1;
            font-size: 13px;
            color: #7181EB;
        }

        img {
            width: 10px;
            height: 15px;
        }
    }
}
</style>